import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMScheduledPrompt } from "../graphql/mutations";
import {
  CreateLLMScheduledPromptInput,
  CreateLLMScheduledPromptMutation,
} from "../API";


export async function createLLMScheduledPromptAfterEdit(
  values: CreateLLMScheduledPromptInput
):Promise<GraphQLResult<CreateLLMScheduledPromptMutation>> {

  console.log("createLLMScheduledPromptAfterEdit", values);


  const r =  API.graphql(
    graphqlOperation(createLLMScheduledPrompt, {
      input: {
        projectId: values.projectId,
        status: values.status,
        agentId: values.agentId,
        title: values.title,
        data: values.data,
        prompt: values.prompt,
        scheduledAt: values.scheduledAt,
        repeatIntervalHours: values.repeatIntervalHours ?? undefined,
        followOnAgentId: values.followOnAgentId ?? undefined,
        followOnFollowOnAgentId: values.followOnFollowOnAgentId ?? undefined,
        followOnTitle: values.followOnTitle ?? undefined,
        followOnPrompt: values.followOnPrompt ?? undefined,
        followOnScheduledAtHours: values.followOnScheduledAtHours ?? undefined,
        followOnNotificationEmailAddresses: values.followOnNotificationEmailAddresses ?? undefined,
        followOnNotificationEmailSubject: values.followOnNotificationEmailSubject ?? undefined,
        followOnRepeatIntervalHours: values.followOnRepeatIntervalHours ?? undefined,
        notificationEmailAddresses: values.notificationEmailAddresses ?? undefined,
        notificationEmailSubject: values.notificationEmailSubject ?? undefined,
      },
    })
  ) as Promise<GraphQLResult<CreateLLMScheduledPromptMutation>>;

  console.log("createLLMScheduledPromptAfterEdit r", r);
  return r;
}
